<template>
  <div class="addFundPayment">
    <div class="newsDetial-header" v-if="id">
      <div v-if="tabnum == 1">
        <div class="newsDetial-title">资金支付申请</div>
        <blank height="7"> </blank>
        <div class="card-title">
          <div class="state1" v-if="Form.state == 1">审批中</div>
          <div class="state2" v-if="Form.state == 2">已归档</div>
          <div class="state3" v-if="Form.state == 3">退回</div>
          <div class="state4" v-if="Form.state == 4">取消</div>
        </div>
      </div>
      <div v-else>
        <div class="newsDetial-title">资金支付审批流程</div>
        <blank height="7"> </blank>
        <a-button
          v-if="Form.state == 2"
          class="detial-top-btn"
          type="primary"
          icon="printer"
          @click="printDDD()"
        >
          打印
        </a-button>
      </div>
      <a-tabs v-model="tabnum" @change="tabClick">
        <a-tab-pane key="1" tab="表单详情" />
        <!-- 草稿未开启审批流不展示跳转审批流按钮 -->
        <a-tab-pane key="2" tab="表单流程" v-if="Form.state > 0" />
      </a-tabs>
    </div>
    <div class="newsDetial-header" v-else>
      <div class="newsDetial-title">新建表单</div>
      <blank height="15"> </blank>
      <div class="newsDetial-abstract">
        请按照要求填写相关信息，并提交进行流程审批
      </div>
      <blank height="45"> </blank>
    </div>
    <div class="detial-cont" v-if="tabnum == 1">
      <div class="detial-cont-title">申请表单</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item>
            <span slot="label">部门/单位 <span class="required">*</span></span>
            <a-tooltip placement="topLeft" :title="Form.organizationName">
              <div>
                <a-input
                  v-if="id"
                  class="w300"
                  placeholder="请添加"
                  v-model="Form.organizationName"
                  disabled
                />
                <a-select
                  v-else
                  class="w300"
                  placeholder="请选择"
                  v-model="Form.organizationId"
                  :disabled="disabled"
                >
                  <a-select-option
                    v-for="item in organizationUserList"
                    :value="item.organizationId"
                    :key="item.organizationId"
                  >
                    {{ item.organizationname }}</a-select-option
                  >
                </a-select>
              </div>
            </a-tooltip>
          </a-descriptions-item>

          <a-descriptions-item>
            <span slot="label">申请人 <span class="required">*</span></span>
            <a-input
              class="w300"
              placeholder="请输入"
              v-model="Form.applypeople"
              :disabled="true"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">申请时间 <span class="required">*</span></span>
            <a-date-picker
              class="w300"
              v-model="Form.applydata"
              :valueFormat="dateFormat"
              :disabled="disabled"
            />
          </a-descriptions-item>

          <a-descriptions-item>
            <span slot="label"
              >收款单位名称 <span class="required">*</span></span
            >

            <!-- <a-select
              mode="combobox"
              class="w300"
              placeholder="请选收款单位名称"
              v-model="Form.collectionCompanyName"
              :disabled="disabled"
              @change="CompanyNameChange"
            >
              <a-select-option
                v-for="item in CollectionList"
                :value="item.collectionCompanyName"
                :key="item.id"
                :label="item.id"
              >
                {{ item.collectionCompanyName }}
              </a-select-option>
            </a-select> -->
            <a-input
              style="width: 215px"
              placeholder="请选择收款单位名称"
              v-model="Form.collectionCompanyName"
              :disabled="disabled"
              @change="upChange"
            />
            <a-button
              type="primary"
              v-if="Form.state != 1"
              class="ml20"
              @click="getCollect()"
            >
              选择
            </a-button>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >收款单位账号 <span class="required">*</span></span
            ><a-input
              class="w300"
              placeholder="请输入账号"
              v-model="Form.collectionCompanyNumber"
              :disabled="disabled"
              :min="0"
              @change="upChange"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">开户银行 <span class="required">*</span></span>
            <a-input
              class="w300"
              placeholder="请输入开户银行"
              v-model="Form.bank"
              :disabled="disabled"
              @change="upChange"
            />
          </a-descriptions-item>
          <a-descriptions-item label="地址">
            <a-input
              class="w300"
              placeholder="请输入地址"
              v-model="Form.address"
              :disabled="disabled"
              @change="eightyfive('address', 85)"
            />
          </a-descriptions-item>
          <a-descriptions-item label="电话">
            <a-input
              class="w300"
              placeholder="请输入"
              v-model="Form.phone"
              :disabled="disabled"
              @blur="phoneChange"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >合计金额（小写）<span class="required">*</span></span
            >
            <a-input-number
              :min="0"
              :max="1000000000"
              class="w300"
              placeholder="请输入金额"
              v-model="Form.famount"
              disabled
              @change="changeNum"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >合计金额（大写）<span class="required">*</span></span
            >
            <a-input
              class="w300"
              placeholder="请输入金额"
              v-model="Form.wamount"
              disabled
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >原始凭单粘贴簿（或附件）张数<span class="required">*</span></span
            >
            <a-input-number
              class="w300"
              :min="0"
              :max="10000"
              placeholder="请输入张数"
              v-model="Form.attachment"
              :disabled="disabled"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">付款方式 <span class="required">*</span></span>
            <a-select
              class="w300"
              placeholder="请选择"
              v-model="Form.paymentterm"
              :disabled="disabled"
            >
              <a-select-option
                v-for="item in paymentwayValList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <template v-if="Form.paymentterm == '1799'">
            <a-descriptions-item>
              <span slot="label"
                >其他付款方式<span class="required">*</span></span
              >
              <a-input
                class="w300"
                placeholder="请输入付款方式"
                v-model="Form.supplement"
                :disabled="disabled"
              />
            </a-descriptions-item>
            <br />
            <br />
          </template>
          <a-descriptions-item label="备注">
            <a-input
              class="w500"
              v-model="Form.title"
              type="textarea"
              :auto-size="{ minRows: 4, maxRows: 6 }"
              :disabled="disabled"
              @change="eightyfive('title', 200)"
            />
          </a-descriptions-item>
        </a-descriptions>
      </div>
      <blank height="3"> </blank>
      <div class="detial-cont-view">
        <a-table
          :pagination="false"
          :columns="instructionsColumns"
          :data-source="instructions"
          :row-key="(record, index) => index"
        >
          <div slot="order" slot-scope="text, record, index">
            {{ index + 1 }}
          </div>
          <div slot="description" slot-scope="text, record">
            <a-input
              :disabled="disabled"
              class="wml10"
              placeholder="请填写支付描述"
              v-model="record.description"
            />
          </div>
          <div slot="money" slot-scope="text, record">
            <a-input-number
              :min="0"
              :max="1000000000"
              :disabled="disabled"
              class="w300 ml10 mr10"
              placeholder="请输入金额"
              v-model="record.money"
              @blur="changeNumber()"
            />元
          </div>
        </a-table>

        <div class="accessory-btn" v-if="!disabled">
          <a-button icon="plus" @click="addcate">资金支付说明 </a-button>
        </div>
      </div>
    </div>
    <div class="detial-cont" v-if="tabnum == 1">
      <!-- 附件 -->
      <accessories-table
        v-model="updateList"
        :file="updateList"
        :disabled="disabled"
      ></accessories-table>
    </div>
    <div class="detial-cont" v-if="tabnum == 2">
      <div class="detial-cont-title">审批流程图示</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <!-- 审批流 表单流程 -->
        <keep-alive>
          <approvalChart
            ref="refChart"
            :approvalChartData="approvalChartData"
          ></approvalChart>
        </keep-alive>
      </div>
    </div>
    <appfloor v-if="tabnum == 2"></appfloor>
    <template v-if="tabnum == 1">
      <bottomSuspension>
        <a-button :style="{ marginRight: '20px' }" @click="goback">
          返回
        </a-button>
        <!-- 表单为可编辑状态 显示提交按钮 -->
        <template>
          <div v-if="proQueryParams.isEdit === '0' ? true : false">
            <a-button
              :loading="confirmLoading && Form.draft == 2"
              type="primary"
              class="orange-btn"
              @click="preserveFn('0')"
              :style="{ marginRight: '20px' }"
            >
              保存
            </a-button>
          </div>
          <a-button
            v-if="!Form.state && !disabled"
            :loading="confirmLoading && Form.draft == 1"
            type="primary"
            class="orange-btn"
            @click="preserveFn('1')"
            :style="{ marginRight: '20px' }"
          >
            保存
          </a-button>
          <a-button
            v-if="!Form.state && !disabled"
            :loading="loading && Form.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            提交
          </a-button>
          <a-button
            v-if="proQueryParams.showApproveBtn === '1'"
            :loading="loading && Form.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            {{ Form.state === 3 ? '提交' : '审批' }}
          </a-button>
        </template>
        <div v-if="proQueryParams.showApproveBtn === '1' ? true : false">
          <a-button
            v-if="Form.state === 3 ? true : false"
            type="danger"
            @click="cancelPro('2')"
            :style="{ marginRight: '20px' }"
          >
            删除
          </a-button>
        </div>
        <!-- <a-button
          v-if="Form.state === 3 ? true : false"
          type="primary"
          @click="cancelPro('1')"
          :style="{ marginRight: '20px' }"
        >
          提交
        </a-button> -->
        <!-- <div v-if="Form.state === 3 ? false : true">
          <a-button
            v-if="proQueryParams.showApproveBtn === '1' ? true : false"
            @click="approvalPro"
            type="primary"
            :style="{ marginRight: '42px' }"
          >
            审批
          </a-button>
        </div> -->
      </bottomSuspension>
    </template>
    <!-- 审批流审批弹窗 -->
    <approvalSubmission v-model="isActivitiMode"></approvalSubmission>
    <print
      v-model="isPrint"
      v-if="Form.state == 2"
      :id="id"
      mobilePath="/pages/workbench/fundPayment/details?id="
      skipPageReqFlag="/FundPaymentDetial"
    >
      <div class="print-title">资金支付申请单</div>
      <div class="printd-cont">
        <div class="printd-item">
          <a-descriptions bordered size="small">
            <a-descriptions-item label="部门/公司名称" :span="1.5">
              {{ Form.organizationName }}
            </a-descriptions-item>
            <a-descriptions-item label="申请人" :span="1.5">
              {{ Form.applypeople }}
            </a-descriptions-item>
            <a-descriptions-item label="申请日期" :span="3">
              {{ getday() }}
            </a-descriptions-item>
            <a-descriptions-item label="付款方式" :span="3">
              现金【 <span v-if="Form.paymentterm == '1700'">√</span> 】
              汇款【<span v-if="Form.paymentterm == '1701'">√</span> 】 支票【
              <span v-if="Form.paymentterm == '1702'">√</span>】 其他方式
              <span v-if="Form.paymentterm == '1799'"
                >【{{ Form.supplement }}】</span
              >
            </a-descriptions-item>

            <a-descriptions-item label="收款单位名称" :span="1.5">
              {{ Form.collectionCompanyName }}
            </a-descriptions-item>
            <a-descriptions-item label="收款单位账号" :span="1.5">
              {{ Form.collectionCompanyNumber }}
            </a-descriptions-item>
            <a-descriptions-item label="地址" :span="3">
              {{ Form.address }}
            </a-descriptions-item>
            <a-descriptions-item label="开户行" :span="1.5">
              {{ Form.bank }}
            </a-descriptions-item>
            <a-descriptions-item label="电话" :span="1.5">
              {{ Form.phone }}
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div class="printd-item">
          <a-table
            size="small"
            :pagination="false"
            :columns="columns2"
            :data-source="instructions"
            :row-key="(record) => record.id"
            bordered
          >
            <div slot="order" slot-scope="text, record, index">
              {{ index + 1 }}
            </div>
          </a-table>
        </div>
        <div class="printd-item">
          <a-descriptions bordered size="small">
            <a-descriptions-item label="合计金额：（小写）￥" :span="3">
              {{ Form.famount }}
            </a-descriptions-item>
            <a-descriptions-item label="合计金额：（大写）￥" :span="3">
              {{ Form.wamount }}
            </a-descriptions-item>
            <a-descriptions-item label="原始凭单粘贴簿（或附件）张数" :span="3">
              {{ Form.attachment }}张
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div class="printd-item">
          <a-table
            size="small"
            :pagination="false"
            :columns="columns"
            :data-source="formDTOList"
            :row-key="(record) => record.id"
            bordered
          >
          </a-table>
        </div>
      </div>
    </print>
    <a-modal
      v-model="visible"
      title="请选择收款账号"
      width="800px"
      :footer="null"
    >
      <a-input
        allowClear
        class="w300 mr20"
        placeholder="请输入收款人/收款单位名称"
        v-model="header"
      />
      <a-button
        type="primary"
        @click="collectionMit"
        :loading="collectionloading"
      >
        查询</a-button
      >
      <a-table
        class="mt20"
        :rowKey="(record) => record.id"
        :pagination="false"
        :columns="columns3"
        :data-source="listData"
        :loading="collectionloading"
      >
        <div slot="action" slot-scope="text, record">
          <a-button
            type="link"
            class="btn-link"
            @click="setItCollection(record)"
          >
            确定
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :size="size"
          :total="total"
          @change="pageChange"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  updatePayMoney,
  PayMoneyDetial,
  addPayMoney,
  sysCollection
} from './api/api'
import AccessoriesTable from '@/components/accessories-table/index.vue'
import approvalSubmission from '@/components/approval-submission/index'
import approvalChart from '@/components/approval-chart/index'
import { activitiSubmission } from '@/utils/utils'
import { validatorPhone, formatDateNoDetails } from '@/assets/js/auth'
export default {
  data() {
    return {
      isPrint: false, // 打印弹窗
      confirmLoading: false,
      loading: false,
      tabnum: '1', // 1表单页面， 2审批流页面
      Form: {},
      instructionsColumns: [
        {
          title: '序号',
          dataIndex: 'order',
          key: 'order',
          scopedSlots: { customRender: 'order' },
          width: 80
        },
        {
          title: '付款申请项目说明',
          dataIndex: 'description',
          key: 'description',
          align: 'left',
          scopedSlots: { customRender: 'description' }
        },
        {
          title: '金额',
          dataIndex: 'money',
          key: 'money',
          align: 'left',
          scopedSlots: { customRender: 'money' },
          ellipsis: true
        }
      ],
      instructions: [], //申请项目说明
      updateList: [], //申请项目文件附件
      id: '',
      dateFormat: 'YYYY-MM-DD',
      data: [],
      // 审批流部分
      // disabled: true,
      isActivitiMode: {
        isActivitiShow: false,
        proQueryParams: []
      },
      proQueryParams: [],
      // 审批流部分

      columns: [
        {
          title: '审批部门（人）',
          dataIndex: 'dutyOfficerStr',
          key: 'dutyOfficerStr',
          align: 'left'
        },
        {
          title: '审批意见',
          dataIndex: 'fieldValue1',
          key: 'fieldValue1',
          align: 'left'
        },
        {
          title: '审批时间',
          dataIndex: 'createTime',
          key: 'createTime',
          align: 'left'
        }
      ],
      columns2: [
        {
          title: '序号',
          dataIndex: 'order',
          key: 'order',
          scopedSlots: { customRender: 'order' }
        },
        {
          title: '付款申请项目说明',
          dataIndex: 'description',
          key: 'description',
          align: 'left'
        },
        {
          title: '付款申请项目说明',
          dataIndex: 'money',
          key: 'money',
          align: 'left'
        }
      ],
      columns3: [
        {
          title: '收款单位名称',
          dataIndex: 'collectionCompanyName',
          key: 'collectionCompanyName',
          align: 'left',
          ellipsis: true
        },
        {
          title: '收款方单位账号',
          dataIndex: 'collectionCompanyNumber',
          key: 'collectionCompanyNumber',
          align: 'left',
          ellipsis: true
        },
        {
          title: '开户行',
          dataIndex: 'bank',
          key: 'bank',
          align: 'left',
          ellipsis: true
        },

        {
          key: 'operation',
          scopedSlots: { customRender: 'action' },
          title: '操作',
          width: 80,
          align: 'center'
        }
      ],
      visible: false,
      collectionloading: false,
      header: '',
      listData: [], //账号列表
      page: 1,
      size: '5',
      total: 0,
      formDTOList: [],
      CollectionList: [], //收款资料表
      ifAbleAdd: true,
      pIsedit: ''
    }
  },
  components: {
    AccessoriesTable,
    approvalSubmission,
    approvalChart
  },
  computed: {
    ...mapState({
      organizationUserList: (state) => state.app.organizationUserList, // 当前用户可选部门
      paymentwayValList: (state) => state.bytype.paymentwayValList, // 付款方式
      queryUserList: (state) => state.app.queryUserList, // 用户列表
      organizationId: (state) => state.app.organizationId // 当前用户部门id
    }),
    // 获取表单是否可编辑状态  false可编辑  true不可编辑
    disabled: function () {
      if (!this.id) {
        // id不存在  为添加  可编辑
        return false
      } else {
        this.proQueryParams = this.$route.query
        if (this.proQueryParams.isEdit) {
          if (
            this.proQueryParams.isEdit === '100' ||
            this.proQueryParams.isEdit === '1'
          ) {
            return true
          } else {
            return false
          }
        } else if (this.Form.state == 1 || this.Form.state == 2) {
          //审批状态和归档状态  不可编辑
          return true
        } else {
          // 草稿箱或退回状态  可编辑
          return false
        }
      }
    }
  },
  created() {
    this.getorganizationUserList()
    this.getpaymentwayVal()
    // sysCollection().then((res) => {
    //   if (res.data.code == 0) {
    //     this.CollectionList = res.data.data;
    //   }
    // });
    this.id = this.$route.query.id ? this.$route.query.id : ''
    if (this.id) {
      this.PayMoneyDetialFn()
    } else {
      this.Form.applypeople = this.$store.state.app.userInfo.fullName
      let date = new Date()
      this.$set(this.Form, 'applydata', formatDateNoDetails(date))
      this.$set(this.Form, 'paymentterm', '1701')
      this.$set(
        this.Form,
        'organizationId',
        this.$store.state.app.organizationId
      )
    }
  },
  methods: {
    // 选中当前账号
    setItCollection(record) {
      this.$set(
        this.Form,
        'collectionCompanyName',
        record.collectionCompanyName
      )
      this.$set(
        this.Form,
        'collectionCompanyNumber',
        record.collectionCompanyNumber
      )
      this.$set(this.Form, 'bank', record.bank)
      this.visible = false
    },

    collectionMit() {
      this.page = 1
      this.collectionList()
    },
    getCollect() {
      this.header = ''
      this.page = 1
      this.collectionList()
      this.visible = true
    },
    // 拉账号表
    collectionList() {
      this.collectionloading = true
      const params = {}
      params.page = this.page
      params.size = this.size
      params.header = this.header

      sysCollection(params).then((res) => {
        this.collectionloading = false
        if (res.data.code == 0) {
          this.listData = res.data.data
          this.total = res.data.count
        }
      })
    },
    pageChange(pageNumber) {
      this.page = pageNumber
      this.collectionList()
    },
    changeNumber() {
      //计算合计金额
      let allNumber = 0
      this.instructions.forEach((item, index) => {
        if (item.money) {
          allNumber += item.money
        }
      })
      this.Form.famount = allNumber
      this.changeNum()
      this.$forceUpdate()
    },
    // 输入框限制85
    eightyfive(v, maxNum) {
      if (this.Form[v].length > maxNum) {
        this.Form[v] = this.Form[v].substring(0, maxNum)
        this.$message.destroy()
        this.$message.warning('只能输入' + maxNum + '个字')
      }
    },
    // CompanyNameChange(e, option) {
    //   let id = option.componentOptions.propsData.label;
    //   this.CollectionList.forEach((v, k) => {
    //     if (v.id == id) {
    //       let { collectionCompanyNumber, bank } = v;
    //       this.Form.collectionCompanyNumber = collectionCompanyNumber;
    //       this.Form.bank = bank;
    //       this.upChange();
    //       return;
    //     }
    //   });
    //   // collectionCompanyNumber 收款单位账号   bank 开户银行
    // },
    upChange() {
      this.$forceUpdate()
    },
    getday() {
      let date = new Date()
      return formatDateNoDetails(date)
    },
    printDDD() {
      this.formDTOList = this.$refs.refChart.getHighLine.formDTOList
      this.isPrint = true
      document.title =
        '资金支付-' + this.Form.applypeople + this.$printFormatDate(new Date())
    },
    PayMoneyDetialFn() {
      PayMoneyDetial({ id: this.id }).then((res) => {
        if (res.data.code == 0) {
          this.Form = res.data.data
          this.updateList = this.Form.file
          this.instructions = this.Form.instructions
          // 多个对象合并合并多个
          let processInstanceId = {
            processInstanceId: res.data.data.processInstanceId,
            detailsData: res.data.data
          }
          Object.assign(this.proQueryParams, processInstanceId)
        }
      })
    },
    // 审批流取消
    cancelPro(key) {
      switch (key) {
        case '1':
          // 提交
          this.$confirm({
            title: '您是否提交?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '1', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break
        case '2':
          // 取消
          this.$confirm({
            title: '您是否取消?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '2', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break

        default:
          break
      }
    },
    // 切换审批流 表单流程
    tabClick(key) {
      if (key == 2) {
        this.approvalChartData = this.proQueryParams
      } else {
        this.PayMoneyDetialFn()
      }
    },
    // 固定资产 申请模块 工作流审批
    approvalPro() {
      this.isActivitiMode = {
        isActivitiShow: true,
        proQueryParams: this.proQueryParams
      }
    },
    ...mapActions(['getorganizationUserList', 'getpaymentwayVal']),
    changeNumMoneyToChinese(money) {
      let that = this
      var cnNums = new Array(
        '零',
        '壹',
        '贰',
        '叁',
        '肆',
        '伍',
        '陆',
        '柒',
        '捌',
        '玖'
      ) //汉字的数字
      var cnIntRadice = new Array('', '拾', '佰', '仟') //基本单位
      var cnIntUnits = new Array('', '万', '亿', '兆') //对应整数部分扩展单位
      var cnDecUnits = new Array('角', '分', '毫', '厘') //对应小数部分单位
      // var cnInteger = '整' //整数金额时后面跟的字符
      var cnInteger = '' //整数金额时后面跟的字符
      var cnIntLast = '元' //整型完以后的单位
      var maxNum = 999999999999999.9999 //最大处理的数字
      var IntegerNum //金额整数部分
      var DecimalNum //金额小数部分
      var ChineseStr = '' //输出的中文金额字符串
      var parts //分离金额后用的数组，预定义
      var Symbol = '' //正负值标记
      if (money == '') {
        return ''
      }

      money = parseFloat(money)
      if (money >= maxNum) {
        // that.$message.warning('超出最大处理数字')
        // alert('超出最大处理数字')
        return ''
      }
      if (money == 0) {
        ChineseStr = cnNums[0] + cnIntLast + cnInteger
        return ChineseStr
      }
      if (money < 0) {
        money = -money
        Symbol = '负 '
      }
      money = money.toString() //转换为字符串
      if (money.indexOf('.') == -1) {
        IntegerNum = money
        DecimalNum = ''
      } else {
        parts = money.split('.')
        IntegerNum = parts[0]
        DecimalNum = parts[1].substr(0, 4)
      }
      if (parseInt(IntegerNum, 10) > 0) {
        //获取整型部分转换
        var zeroCount = 0
        var IntLen = IntegerNum.length
        for (var i = 0; i < IntLen; i++) {
          var n = IntegerNum.substr(i, 1)
          var p = IntLen - i - 1
          var q = p / 4
          var m = p % 4
          if (n == '0') {
            zeroCount++
          } else {
            if (zeroCount > 0) {
              ChineseStr += cnNums[0]
            }
            zeroCount = 0 //归零
            ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
          }
          if (m == 0 && zeroCount < 4) {
            ChineseStr += cnIntUnits[q]
          }
        }
        ChineseStr += cnIntLast
        //整型部分处理完毕
      }
      if (DecimalNum != '') {
        //小数部分
        var decLen = DecimalNum.length
        for (var i = 0; i < decLen; i++) {
          var n = DecimalNum.substr(i, 1)
          if (n != '0') {
            ChineseStr += cnNums[Number(n)] + cnDecUnits[i]
          }
        }
      }
      if (ChineseStr == '') {
        ChineseStr += cnNums[0] + cnIntLast + cnInteger
      } else if (DecimalNum == '') {
        ChineseStr += cnInteger
      }
      ChineseStr = Symbol + ChineseStr

      return ChineseStr
    },
    goback() {
      this.$router.push('/FundPayment')
    },
    addcate() {
      if (this.instructions.length < 4) {
        this.ifAbleAdd = true
        // 判断当前表格是否含有空数据
        if (this.instructions && this.instructions.length != 0) {
          this.instructions.forEach((item, index) => {
            if (!item.description && !item.money) {
              this.$message.warning('请先输入当前付款申请项目说明')
              this.ifAbleAdd = false
            }
          })
        }
        if (this.ifAbleAdd == true) {
          let data = {}
          this.instructions.push(data)
        }
      } else {
        this.$message.warning(
          '为了方便快速浏览，请放置4条以内的支付描述，文本不能添加的请再提交资金支付申请表单'
        )
      }
    },
    preserveFn(type) {
      if (type === '0') {
        // 自定义保存判断 1 = 仅保存
        this.pIsedit = '1'
        this.Form.draft = 2
      } else {
        this.pIsedit = '2'
        this.Form.draft = 1
      }
      if (!this.Form.organizationId) {
        this.$message.error('请添加部门')
        return false
      }
      if (!this.Form.applydata) {
        this.$message.error('请添加申请时间')
        return
      }
      if (!this.Form.collectionCompanyName) {
        this.$message.error('请填写收款单位')
        return
      }
      if (!this.Form.collectionCompanyNumber) {
        this.$message.error('请填写收款单位账号')
        return
      }
      if (!this.Form.bank) {
        this.$message.error('请填写开户银行')
        return
      }
      if (!this.Form.famount) {
        this.$message.error('请填写合计金额')
        return
      }
      if (!this.Form.attachment) {
        this.$message.error('请填写原始凭单粘贴簿（或附件）张数')
        return
      }
      if (!this.Form.paymentterm) {
        this.$message.error('请填写付款方式')
        return
      }
      if (this.Form.paymentterm == '1799' && !this.Form.supplement) {
        this.$message.error('请填写付款方式')
        return
      }
      //检测付款说明必须大于两个字
      let aaa = this.instructions.every((item) => {
        return item.description && item.description.length > 1
      })
      if (!aaa) {
        this.$message.error('付款申请项目说明必须大于两个字')
        return
      }
      this.confirmLoading = true
      this.saveFormFn('保存')
    },

    submitFn() {
      if (!this.Form.organizationId) {
        this.$message.error('请添加部门')
        return false
      }
      if (!this.Form.applydata) {
        this.$message.error('请添加申请时间')
        return
      }
      if (!this.Form.collectionCompanyName) {
        this.$message.error('请填写收款单位')
        return
      }
      if (!this.Form.collectionCompanyNumber) {
        this.$message.error('请填写收款单位账号')
        return
      }
      if (!this.Form.bank) {
        this.$message.error('请填写开户银行')
        return
      }
      if (!this.Form.famount) {
        this.$message.error('请填写合计金额')
        return
      }
      if (!this.Form.attachment) {
        this.$message.error('请填写原始凭单粘贴簿（或附件）张数')
        return
      }
      if (!this.Form.paymentterm) {
        this.$message.error('请填写付款方式')
        return
      }
      if (this.Form.paymentterm == '1799' && !this.Form.supplement) {
        this.$message.error('请填写付款方式')
        return
      }
      //检测付款说明必须大于两个字
      let aaa = this.instructions.every((item) => {
        return item.description && item.description.length > 1
      })
      if (!aaa) {
        this.$message.error('付款申请项目说明必须大于两个字')
        return
      }
      if (this.Form.state > 0) {
        this.Form.draft = 2
        this.saveFormFn('添加')
      } else {
        this.$confirm({
          title: '确定提交吗?',
          okType: 'danger',
          onOk: () => {
            this.Form.draft = 2
            this.saveFormFn('添加')
          }
        })
      }
    },
    changeNum() {
      if (this.Form.famount > 10000000000) {
        this.$message.warning('金额最大为1000000000')
      }
      this.Form.wamount = this.changeNumMoneyToChinese(this.Form.famount)
    },
    saveFormFn(type) {
      this.Form.file = this.updateList
      this.Form.instructions = this.instructions
      this.Form.appId = this.$route.meta.appId
      this.Form.skipPageReqFlag = '/FundPaymentDetial'
      if (this.pIsedit === '') {
        this.loading = true
      } else {
        this.confirmLoading = true
      }
      if (this.id) {
        updatePayMoney(this.Form).then((res) => {
          if (res.data.code == 0) {
            if (this.pIsedit === '1') {
              this.$message.success('保存成功')
              this.pIsedit = ''
            } else {
              if (this.Form.state > 0) {
                this.PayMoneyDetialFn()
                // 合并 保存+审批流操作
                if (
                  this.proQueryParams.showApproveBtn === '1' &&
                  this.Form.state != '3'
                ) {
                  this.approvalPro()
                } else {
                  this.cancelPro('1')
                }
                // this.$message.success('修改成功')
                // 合并 保存+审批流操作
              } else {
                if (this.Form.draft == 2) {
                  this.$message.success('提交成功')
                  this.goback()
                } else {
                  this.$message.success('保存成功')
                }
              }
            }
            this.loading = false
            this.confirmLoading = false
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      } else {
        //获取部门名称
        let organizationName = ''
        this.organizationUserList.forEach((item, index) => {
          if (item.organizationId == this.Form.organizationId) {
            organizationName = item.organizationname
          }
        })
        this.Form.organizationName = organizationName
        addPayMoney(this.Form).then((res) => {
          if (res.data.code == 0) {
            this.$message.success(type + '成功')
            if (this.Form.draft == 2) {
              this.goback()
            } else {
              //首次添加
              this.id = res.data.data
              this.PayMoneyDetialFn()
            }
            this.loading = false
            this.confirmLoading = false
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      }
    },
    phoneChange() {
      if (!this.Form.phone) return
      let isPhone = validatorPhone(this.Form.phone)
      if (!isPhone) {
        this.Form.phone = ''
        this.$message.error('请输入正确的手机号！')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.addFundPayment {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
// 打印内容不能嵌套写样式

.print-title {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
}
</style>

<style scoped src="@/assets/css/printModal.css"></style>



// WEBPACK FOOTER //
// src/views/FundPayment/detial.vue